import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  withCredentials: true
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve();
  });
  failedQueue = [];
};

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/')) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => API(originalRequest));
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        await API.post('/auth/refresh');
        processQueue(null);
        return API(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        localStorage.removeItem('member');
        window.location.href = '/';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export const login = (data) => API.post('/auth/login', data);
export const register = (data) => API.post('/auth/register', data);
export const logout = () => API.post('/auth/logout');
export const refreshToken = () => API.post('/auth/refresh');
export const requestPasswordReset = (email) => API.post('/password-reset/request', { email });
export const resetPassword = (token, password) => API.post('/password-reset/reset', { token, password });
export const getMe = () => API.get('/members/me');
export const getMembers = (page = 1, limit = 20, search = '', status = 'all') => API.get(`/members?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&status=${status}`);
export const getFinancials = () => API.get('/members/financials');
export const getOverview = () => API.get('/members/overview');
export const createCheckout = (payment_type, entries = 1) => API.post('/payments/create-checkout', { payment_type, entries });
export const updateEntries = (entries) => API.post('/payments/update-entries', { entries });
export const getPaymentHistory = () => API.get('/payments/history');
export const getDraws = (page = 1, limit = 20) => API.get(`/draws?page=${page}&limit=${limit}`);
export const getMyWins = () => API.get('/draws/my-wins');
export const runDraw = () => API.post('/draws/run');
export const getSettings = (year) => API.get(`/settings/${year}`);
export const getMemberSettings = () => API.get('/settings/public/current');
export const saveSettings = (data) => API.post('/settings', data);

export default API;
